import {Pipe, PipeTransform} from '@angular/core';
import {ISmaeResult} from '../../class/macronutrient-distribution-strategy/enums/smae-result.interface';

@Pipe({
  name: 'calSmaeResult'
})
export class CalSmaeResultPipe implements PipeTransform {

  transform([sum, goal]: [ISmaeResult, ISmaeResult]): ISmaeResult | null {
    if (!sum || !goal) return null;
    return {
      label: 'Adecuación',
      calories: goal.calories === 0 ? 0 : Number(((sum.calories * 100) / goal.calories).toFixed(2)),
      protein: goal.protein === 0 ? 0 : Number(((sum.protein * 100) / goal.protein).toFixed(2)),
      fiber: 0, // Number(((sum.fiber * 100) / goal.fiber).toFixed(2)), // No se sabe como se calculará esta propiedad
      lipids: goal.lipids === 0 ? 0 : Number(((sum.lipids * 100) / goal.lipids).toFixed(2)),
      carbohydrates: goal.carbohydrates === 0 ? 0 : Number(((sum.carbohydrates * 100) / goal.carbohydrates).toFixed(2)),
    };
  }
}
